import Play from './play';
import PlayCircle from './play-circle';

export const SvgPlay = Play;
export const SvgPlayCircle = PlayCircle;
